var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaveIcos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17.5,
    stroke: "#27295B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.5071V23.0366",
    stroke: "#27295B",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8809 14.2681V23.0429",
    stroke: "#27295B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 8H18.6808",
    stroke: "#27295B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 25.5496H22.401",
    stroke: "#27295B",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8805 23.0425C24.8873 24.2946 23.6405 25.5496 22.4004 25.5496",
    stroke: "#27295B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 23.0425C10.0003 24.296 11.2404 25.5496 12.4805 25.5496",
    stroke: "#27295B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 10.5054C10.0003 9.25364 11.2404 8.02801 12.4805 8.0001",
    stroke: "#27295B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8733 14.2734L18.6797 8",
    stroke: "#27295B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.68 11.761C18.6838 13.0077 19.9251 14.2681 21.1602 14.2681",
    stroke: "#27295B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6797 11.7606V8",
    stroke: "#27295B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1602 14.2681H24.8804",
    stroke: "#27295B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 23.0425H16.2007",
    stroke: "#27295B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 20.5354H18.6808",
    stroke: "#27295B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 18.0286H16.2007",
    stroke: "#27295B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5648 27.8766C25.0146 27.8766 27.0006 25.8906 27.0006 23.4407C27.0006 20.9909 25.0146 19.0049 22.5648 19.0049C20.1149 19.0049 18.1289 20.9909 18.1289 23.4407C18.1289 25.8906 20.1149 27.8766 22.5648 27.8766Z",
    fill: "white",
    stroke: "#27295B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0067 24.3015V24.0775H23.1547V24.3015H21.0067ZM21.0067 23.7495V23.5255H23.1547V23.7495H21.0067ZM22.8947 25.3455C22.6841 25.3455 22.4881 25.3108 22.3067 25.2415C22.1281 25.1695 21.9721 25.0695 21.8387 24.9415C21.7054 24.8108 21.6014 24.6588 21.5267 24.4855C21.4521 24.3121 21.4147 24.1215 21.4147 23.9135C21.4147 23.7055 21.4521 23.5148 21.5267 23.3415C21.6014 23.1681 21.7054 23.0175 21.8387 22.8895C21.9721 22.7588 22.1281 22.6588 22.3067 22.5895C22.4881 22.5175 22.6841 22.4815 22.8947 22.4815C23.1134 22.4815 23.3147 22.5188 23.4987 22.5935C23.6827 22.6655 23.8374 22.7735 23.9627 22.9175L23.7067 23.1695C23.5974 23.0575 23.4761 22.9748 23.3427 22.9215C23.2121 22.8655 23.0694 22.8375 22.9147 22.8375C22.7574 22.8375 22.6121 22.8641 22.4787 22.9175C22.3454 22.9708 22.2281 23.0455 22.1267 23.1415C22.0281 23.2375 21.9521 23.3521 21.8987 23.4855C21.8454 23.6161 21.8187 23.7588 21.8187 23.9135C21.8187 24.0681 21.8454 24.2121 21.8987 24.3455C21.9521 24.4761 22.0281 24.5895 22.1267 24.6855C22.2281 24.7815 22.3454 24.8561 22.4787 24.9095C22.6121 24.9628 22.7574 24.9895 22.9147 24.9895C23.0694 24.9895 23.2121 24.9628 23.3427 24.9095C23.4761 24.8535 23.5974 24.7681 23.7067 24.6535L23.9627 24.9055C23.8374 25.0495 23.6827 25.1588 23.4987 25.2335C23.3147 25.3081 23.1134 25.3455 22.8947 25.3455Z",
    fill: "#27295B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIcos);
export default __webpack_public_path__ + "static/media/SaveIcos.0378b82c48de48b7ed34f8a5b882b282.svg";
export { ForwardRef as ReactComponent };